import React, { CSSProperties, SyntheticEvent, useEffect, useState } from "react";

import { Button, ButtonProps, Dropdown, DropdownProps, Form, FormField } from "semantic-ui-react";

import { useIntl } from "react-intl";

import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";

type DeleteColumnProps = {
  /** แสดงปุ่มเมื่อมี value หรือไม่มี id */
  value?: boolean | string;
  /** ID สำหรับเช็คการแสดงปุ่ม */
  id?: number | string;
  style?: CSSProperties;
  circular?: boolean;
  disabled?: boolean;
  icon?: string;
  nameButton?: string;
  size?: ButtonProps["size"];
  titleColor?: string;
  titleName?: string;
  options?: Record<string, any>[];
  onCancel?: () => void;
  onConfirm?: (note: string) => void;
};

const DeleteColumn = (props: DeleteColumnProps) => {
  const intl = useIntl();

  const [openModConfirm, setOpenModConfirm] = useState<boolean>(false);
  const [options, setOptions] = useState<any[]>([]);
  const [note, setNote] = useState<any[]>([]);

  useEffect(() => {
    setOptions(props.options ?? []);
  }, [props.options]);

  const handleApprove = (e: SyntheticEvent) => {
    props.onConfirm?.(note.join(","));

    handleCloseModConfirm(e);
  };

  const handleCloseModConfirm = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenModConfirm(false);
    setNote([]);

    props.onCancel?.();
  };

  const handleOpenModal = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenModConfirm(true);
  };

  const handleAddOptions = (e: SyntheticEvent, v: any) => {
    setOptions([...options, { key: v.value, text: v.value, value: v.value }]);
  };

  const handleChangeNote = (e: SyntheticEvent, data: DropdownProps) => {
    if (Array.isArray(data.value)) {
      setNote(data.value);
    }
  };

  // แสดงปุ่มเมื่อมี value หรือไม่มี id
  const shouldShowButton = props.value || !props.id;

  return (
    <>
      {!!shouldShowButton && (
        <div style={{ display: "flex", justifyContent: "center", ...props.style }}>
          <Button
            circular={props.circular ?? false}
            color="red"
            disabled={props.disabled}
            icon={props.icon || "minus"}
            size={props.size}
            onClick={handleOpenModal}
          >
            {props.nameButton || null}
          </Button>
        </div>
      )}

      <ModConfirm
        approveButtonText={intl.formatMessage({ id: "ใช่" })}
        denyButtonText={intl.formatMessage({ id: "ไม่" })}
        disabledApproveButton={props.options && note.length === 0}
        modalStyle={{ minWidth: props.options ? "30rem" : "" }}
        openModal={openModConfirm}
        titleColor={props.titleColor}
        titleName={props.titleName ?? "ต้องการลบรายการค่าธรรมเนียมหรือไม่"}
        onApprove={handleApprove}
        onDeny={handleCloseModConfirm}
        content={
          props.options ? (
            <Form>
              <FormField style={{ alignItems: "center", display: "flex", width: "100%" }} inline>
                <label style={{ fontWeight: "bold", marginRight: "1rem" }}>Reason: </label>
                <Dropdown
                  style={{ width: "100%" }}
                  value={note}
                  allowAdditions
                  fluid
                  multiple
                  search
                  selection
                  options={options}
                  onAddItem={handleAddOptions}
                  onChange={handleChangeNote}
                />
              </FormField>
            </Form>
          ) : (
            <div
              style={{
                fontSize: "1.2rem",
                margin: "-0.5rem 0rem -1rem 0rem",
                textAlign: "center",
              }}
            />
          )
        }
      />
    </>
  );
};

export default DeleteColumn;
